<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="title" [back]="true"></app-header>

    <app-steps
        #appSteps
        [steps]="steps"
        [beforeNext]="beforeNext"
        (onPrimary)="onSave()"
        (onSecondary)="previewOfferLetter()"
        [labels]="{ primary: 'offer-letter.sendOffer', secondary: 'offer-letter.previewTemplate' }"
        [options]="{ showSecondaryAction: allowOfferLetterPreviews ? 'LAST_STEP_ONLY' : undefined }"
    >
        <!-- Candidate Information -->
        <app-step
            #candidateInformationStep
            [stepForm]="candidateInformationForm"
            step="{{ 'offer-letter.candidateInformation' | appTranslate }}"
            title="{{ 'offer-letter.candidateInformation' | appTranslate }}"
            stepKey="candidateInformation"
        >
            <app-candidate-information
                #candidateInformationForm
                [offerLetter]="offerLetter"
                [offerLetterTemplates]="offerLetterTemplates"
            ></app-candidate-information>
        </app-step>

        <!-- Letter Template -->
        <app-step
            #letterTemplateStep
            [stepForm]="letterTemplateForm"
            step="{{ 'offer-letter.letterTemplate' | appTranslate }}"
            stepKey="letterTemplate"
            [embeddedCard]="false"
        >
            <app-letter-template
                #letterTemplateForm
                [offerLetter]="offerLetter"
                [offerLetterTemplates]="offerLetterTemplates"
                [offerLetterHasCosigners]="offerLetterHasCosigners"
                (offerLetterHasCosignersChange)="offerLetterHasCosigners = $event"
            ></app-letter-template>
        </app-step>

        <!-- Letter Details -->
        <app-step
            #letterDetailsStep
            [stepForm]="letterDetailsForm"
            step="{{ 'offer-letter.letterDetails' | appTranslate }}"
            title="{{ 'offer-letter.letterDetails' | appTranslate }}"
            stepKey="letterDetails"
        >
            <app-letter-details
                #letterDetailsForm
                [isLoading]="isLetterDetailsStepLoading"
                [offerLetter]="offerLetter"
                [mergeFieldFormInputAttributes]="mergeFieldFormInputAttributes"
            >
            </app-letter-details>
        </app-step>

        <!-- Review -->
        <app-step
            #reviewStep
            [stepForm]="reviewCandidateInformationForm"
            step="{{ 'offer-letter.review' | appTranslate }}"
            title="{{ 'offer-letter.review' | appTranslate }}"
            stepKey="offerLetterReview"
        >
            <app-review-candidate-information
                #reviewCandidateInformationForm
                [offerLetter]="offerLetter"
                [mergeFieldFormInputAttributes]="mergeFieldFormInputAttributes"
                (loading)="isLoading = $event"
                (offerLetterSent)="onSave()"
                [offerLetterHasCosigners]="offerLetterHasCosigners"
            ></app-review-candidate-information>
        </app-step>
    </app-steps>
</div>
